"use strict";var redefine=require("./_redefine");module.exports=function(e,r,i){for(var n in r)redefine(e,n,r[n],i);return e};